const EXPLICIT_VRS = {
  AE: true,
  AS: true,
  AT: true,
  CS: true,
  DA: true,
  DS: true,
  DT: true,
  FL: true,
  FD: true,
  IS: true,
  LO: true,
  LT: true,
  OB: true,
  OD: true,
  OF: true,
  OL: true,
  OW: true,
  PN: true,
  SH: true,
  SL: true,
  SQ: true,
  SS: true,
  ST: true,
  TM: true,
  UC: true,
  UI: true,
  UL: true,
  UN: true,
  UR: true,
  US: true,
  UT: true,
};

const COMMON_GROUPS = {
  0x0002: true,
  0x0008: true,
  0x0010: true,
  0x0018: true,
  0x0020: true,
  0x0028: true,
  0x7fe0: true,
};

const EXPLICIT_VR_LITTLE_ENDIAN = '1.2.840.10008.1.2.1';
const IMPLICIT_VR_LITTLE_ENDIAN = '1.2.840.10008.1.2';
const EXPLICIT_VR_BIG_ENDIAN = '1.2.840.10008.1.2.2';
const JPEG_BASELINE = '1.2.840.10008.1.2.4.50';
const JPEG_EXTENDED = '1.2.840.10008.1.2.4.51';
const JPEG_LOSSLESS = '1.2.840.10008.1.2.4.57';
const JPEG_LS_LOSSLESS = '1.2.840.10008.1.2.4.80';
const JPEG_LS_NEAR_LOSSLESS = '1.2.840.10008.1.2.4.81';
const JPEG2000_LOSSLESS = '1.2.840.10008.1.2.4.90';

const UNCOMPRESSED_SYNTAX = {
  '1.2.840.10008.1.2': true,
  '1.2.840.10008.1.2.1': true,
  '1.2.840.10008.1.2.1.99': true,
  '1.2.840.10008.1.2.2': true,
};

function groupNumber(byteArray, bigEndian) {
  if (bigEndian) {
    return (byteArray[0] << 8) | byteArray[1];
  }
  return byteArray[0] | (byteArray[1] << 8);
}

function isExplicitVR(byteArray) {
  if (!byteArray || byteArray.length < 8) {
    return false;
  }
  const vr = String.fromCharCode(byteArray[4], byteArray[5]);
  return !!EXPLICIT_VRS[vr];
}

function addTransferSyntax(dataSet, transferSyntaxUid) {
  if (dataSet.elements.x00020010) {
    return dataSet;
  }
  return writeTransferSyntax(dataSet, transferSyntaxUid);
}

function writeTransferSyntax(dataSet, transferSyntaxUid) {
  const paddedLength =
    transferSyntaxUid.length + (transferSyntaxUid.length % 2);
  const extra = new Uint8Array(paddedLength);
  for (let i = 0; i < transferSyntaxUid.length; i++) {
    extra[i] = transferSyntaxUid.charCodeAt(i);
  }

  const combined = new Uint8Array(dataSet.byteArray.length + paddedLength);
  combined.set(dataSet.byteArray, 0);
  combined.set(extra, dataSet.byteArray.length);

  dataSet.elements.x00020010 = {
    tag: 'x00020010',
    vr: 'UI',
    length: paddedLength,
    dataOffset: dataSet.byteArray.length,
  };
  dataSet.byteArray = combined;
  return dataSet;
}

function encapsulatedFragment(dataSet) {
  const pixelData =
    dataSet.elements.x7fe00010 || dataSet.elements.x7fe00008;
  if (
    !pixelData ||
    !pixelData.encapsulatedPixelData ||
    !pixelData.fragments ||
    !pixelData.fragments.length
  ) {
    return null;
  }
  return pixelData.fragments[0];
}

function readJpegLsNear(bytes, start, end) {
  let position = start;
  while (position + 4 < end) {
    if (bytes[position] !== 0xff) {
      position++;
      continue;
    }
    const marker = bytes[position + 1];
    if (marker === 0xff) {
      position++;
      continue;
    }
    if (marker === 0xda) {
      const components = bytes[position + 4];
      const nearIndex = position + 5 + components * 2;
      return nearIndex < end ? bytes[nearIndex] : 0;
    }
    if (marker === 0x00 || marker === 0xd8) {
      position += 2;
      continue;
    }
    const segmentLength = (bytes[position + 2] << 8) | bytes[position + 3];
    if (segmentLength < 2) {
      break;
    }
    position += 2 + segmentLength;
  }
  return 0;
}

function sniffEncapsulatedSyntax(dataSet) {
  const fragment = encapsulatedFragment(dataSet);
  if (!fragment || fragment.length < 4) {
    return null;
  }

  const bytes = dataSet.byteArray;
  const offset = fragment.position;
  const end = Math.min(
    bytes.length,
    offset + Math.min(fragment.length, 65536)
  );
  if (
    bytes[offset] === 0xff &&
    bytes[offset + 1] === 0x4f
  ) {
    return JPEG2000_LOSSLESS;
  }
  if (
    bytes[offset] === 0x00 &&
    bytes[offset + 1] === 0x00 &&
    bytes[offset + 2] === 0x00 &&
    bytes[offset + 3] === 0x0c
  ) {
    return JPEG2000_LOSSLESS;
  }
  if (bytes[offset] !== 0xff || bytes[offset + 1] !== 0xd8) {
    return null;
  }

  let position = offset + 2;
  while (position + 4 < end) {
    if (bytes[position] !== 0xff) {
      position++;
      continue;
    }
    const marker = bytes[position + 1];
    if (marker === 0xff) {
      position++;
      continue;
    }
    if (marker === 0x00 || marker === 0xd8) {
      position += 2;
      continue;
    }
    if (marker === 0x01 || (marker >= 0xd0 && marker <= 0xd7)) {
      position += 2;
      continue;
    }
    const segmentLength = (bytes[position + 2] << 8) | bytes[position + 3];
    if (segmentLength < 2) {
      break;
    }
    if (marker === 0xf7) {
      const near = readJpegLsNear(bytes, position + 2 + segmentLength, end);
      return near > 0 ? JPEG_LS_NEAR_LOSSLESS : JPEG_LS_LOSSLESS;
    }
    if (marker === 0xc3 || marker === 0xc7) {
      return JPEG_LOSSLESS;
    }
    if (marker === 0xc0) {
      return JPEG_BASELINE;
    }
    if (marker === 0xc1 || marker === 0xc2) {
      return bytes[position + 4] > 8 ? JPEG_EXTENDED : JPEG_BASELINE;
    }
    if (marker === 0xda || marker === 0xd9) {
      break;
    }
    position += 2 + segmentLength;
  }
  return null;
}

/**
 * 有些文件把 JPEG-LS 封装进 Pixel Data，传输语法却写成未压缩。
 * 按文件头解码会把压缩字节直接画出来，整幅图都是雪花。
 */
function correctEncapsulatedTransferSyntax(dataSet) {
  if (!dataSet || !dataSet.elements) {
    return dataSet;
  }
  const sniffed = sniffEncapsulatedSyntax(dataSet);
  if (!sniffed) {
    return dataSet;
  }
  const declared = dataSet.string ? dataSet.string('x00020010') : undefined;
  if (declared && !UNCOMPRESSED_SYNTAX[declared]) {
    return dataSet;
  }
  if (declared === sniffed) {
    return dataSet;
  }
  return writeTransferSyntax(dataSet, sniffed);
}

function parseRawDataSet(dicomParser, byteArray, explicit, bigEndian) {
  const byteArrayParser = bigEndian
    ? dicomParser.bigEndianByteArrayParser
    : dicomParser.littleEndianByteArrayParser;
  const byteStream = new dicomParser.ByteStream(byteArrayParser, byteArray, 0);
  const dataSet = new dicomParser.DataSet(byteArrayParser, byteArray, {});

  if (explicit) {
    dicomParser.parseDicomDataSetExplicit(
      dataSet,
      byteStream,
      byteArray.length
    );
  } else {
    dicomParser.parseDicomDataSetImplicit(
      dataSet,
      byteStream,
      byteArray.length
    );
  }

  dataSet.warnings = byteStream.warnings || [];

  let transferSyntaxUid = IMPLICIT_VR_LITTLE_ENDIAN;
  if (explicit && bigEndian) {
    transferSyntaxUid = EXPLICIT_VR_BIG_ENDIAN;
  } else if (explicit) {
    transferSyntaxUid = EXPLICIT_VR_LITTLE_ENDIAN;
  }

  return addTransferSyntax(dataSet, transferSyntaxUid);
}

/**
 * CDN 上的部分 .dcm 没有 128 字节前导和 DICM，dicomParser.parseDicom 会直接拒绝。
 * 这类文件从第 0 字节就是数据集，这里按 Explicit/Implicit VR 再解析一次。
 */
export function installDicomParserFallback(dicomParser) {
  if (!dicomParser || dicomParser.parseDicom.__rawDatasetFallback) {
    return;
  }

  const parsePart10 = dicomParser.parseDicom.bind(dicomParser);

  function parseDicom(byteArray, options) {
    try {
      return correctEncapsulatedTransferSyntax(
        parsePart10(byteArray, options)
      );
    } catch (error) {
      const message =
        typeof error === 'string' ? error : error && error.message;
      if (!message || message.indexOf('DICM prefix not found') === -1) {
        throw error;
      }
      if (!byteArray || byteArray.length < 8) {
        throw error;
      }

      const explicit = isExplicitVR(byteArray);
      const littleEndianGroup = groupNumber(byteArray, false);
      const bigEndianGroup = groupNumber(byteArray, true);
      const bigEndian =
        explicit &&
        !COMMON_GROUPS[littleEndianGroup] &&
        !!COMMON_GROUPS[bigEndianGroup];
      const dicomLike =
        explicit ||
        !!COMMON_GROUPS[littleEndianGroup] ||
        !!COMMON_GROUPS[bigEndianGroup];

      if (!dicomLike) {
        throw error;
      }

      try {
        return correctEncapsulatedTransferSyntax(
          parseRawDataSet(dicomParser, byteArray, explicit, bigEndian)
        );
      } catch (fallbackError) {
        throw fallbackError || error;
      }
    }
  }

  parseDicom.__rawDatasetFallback = true;
  dicomParser.parseDicom = parseDicom;
}
